import { online, ping, updateRegisteredEndpoint, register } from "./sipActions";

export function heartbeat(interval) {
  return (dispatch, getstate) => {
    //1 sec
    if (interval === 1) {
      if (getstate().user.authenticated === true) {
        setTimeout(() => dispatch(online()), 2000);
      }
    }

    //5 sec
    if (interval === 5) {
    }

    //20 sec
    if (interval === 20) {
      if (
        getstate().config.browser.name === "ie" ||
        getstate().config.browser.name === "edge"
      ) {
        dispatch(ping());
      }
    }

    //60 sec
    if (interval === 60) {
      if (getstate().user.authenticated === true) {
        dispatch(updateRegisteredEndpoint());

        // Try to re-register with the Freeswitch if there has been a communications error
        if (getstate().network.freeswitchError) {
          dispatch(register());
        }
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/heartbeatActions.js